module.exports = __webpack_public_path__ + "static/img/login.abd53b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/document/login.png
// module id = 4pF3
// module chunks = 0